export default "__VITE_ASSET__ec08519c__"